/* FÉNIX R07.72 — compact runtime guard: FAB + mobile/touch state. */
(function(){
  'use strict';
  function ready(fn){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fn,{once:true});else fn();}
  ready(function(){
    var body=document.body;
    var footer=document.querySelector('footer.site-footer');
    var nav=document.getElementById('MobileNav');
    var fab=document.querySelector('.nm-chat-fab');
    if(!body)return;

    function isCompact(){
      var narrow=window.matchMedia&&window.matchMedia('(max-width:760px)').matches;
      var coarse=window.matchMedia&&window.matchMedia('(max-width:1180px) and (hover:none) and (pointer:coarse)').matches;
      return !!(narrow||coarse);
    }

    function syncCompact(){body.classList.toggle('nm-r072-compact',isCompact());}
    syncCompact();
    window.addEventListener('resize',syncCompact,{passive:true});

    var footerHit=false;
    var menuOpen=false;
    function syncFab(){
      body.classList.toggle('nm-r072-fab-footer',!!footerHit&&isCompact());
      body.classList.toggle('nm-r072-menu-open',!!menuOpen&&isCompact());
      if(fab){
        var hidden=isCompact()&&(footerHit||menuOpen);
        if(hidden){fab.setAttribute('aria-hidden','true');fab.setAttribute('tabindex','-1');}
        else{fab.removeAttribute('aria-hidden');fab.removeAttribute('tabindex');}
      }
    }

    if(footer&&'IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){
        footerHit=!!(entries[0]&&entries[0].isIntersecting);
        syncFab();
      },{root:null,rootMargin:'0px 0px 44px 0px',threshold:0});
      io.observe(footer);
    }

    function readMenu(){
      menuOpen=!!(nav&&nav.classList.contains('is-visible'));
      syncFab();
    }
    if(nav&&'MutationObserver' in window){
      new MutationObserver(readMenu).observe(nav,{attributes:true,attributeFilter:['class']});
      readMenu();
    }else{
      syncFab();
    }
  });
})();
